module.exports = __webpack_public_path__ + "4f994bdc0186e084bae382322c01c81c.MP3";